import React from 'react';
import { ShieldCheck, CheckCircle, RotateCcw, Truck } from 'lucide-react';

const TrustStrip = () => {
  const trustItems = [
    { icon: ShieldCheck, label: 'Clinically Guided', description: 'Expert-curated products' },
    { icon: CheckCircle, label: 'Verified Products', description: 'Quality assured' },
    { icon: RotateCcw, label: 'Easy Returns', description: '30-day guarantee' },
    { icon: Truck, label: 'Fast Delivery', description: '2-5 business days' },
  ];

  return (
    <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {trustItems.map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center flex-shrink-0">
                <item.icon className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900">{item.label}</p>
                <p className="text-xs text-gray-500">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;